var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"multiselect-header"}},[(_vm.selectMode)?_c('div',{key:"multiselect-header",staticClass:"multiselect-header"},[_c('div',{staticClass:"button primary",on:{"click":function($event){$event.preventDefault();return _vm.markSelectedSeenOrUnseen.apply(null, arguments)}}},[_c('span',{attrs:{"id":"action-label"}},[_vm._v(_vm._s(_vm.areAllSelectedRead
						? _vm.n(
							'mail',
							'Mark {number} unread',
							'Mark {number} unread',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						)
						: _vm.n(
							'mail',
							'Mark {number} read',
							'Mark {number} read',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						)))])]),_vm._v(" "),_c('Actions',{staticClass:"app-content-list-item-menu",attrs:{"menu-align":"right"}},[(_vm.isAtLeastOneSelectedUnimportant)?_c('ActionButton',{attrs:{"icon":"icon-important","close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.markSelectionImportant.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
							'mail',
							'Mark {number} as important',
							'Mark {number} as important',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						))+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),(_vm.isAtLeastOneSelectedImportant)?_c('ActionButton',{attrs:{"icon":"icon-important","close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.markSelectionUnimportant.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
							'mail',
							'Mark {number} as unimportant',
							'Mark {number} as unimportant',
							_vm.selection.length,
							{
								number: _vm.selection.length,
							}
						))+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('ActionButton',{attrs:{"icon":"icon-starred","close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.favoriteOrUnfavoriteAll.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.areAllSelectedFavorite
							? _vm.n(
								'mail',
								'Unfavorite {number}',
								'Unfavorite {number}',
								_vm.selection.length,
								{
									number: _vm.selection.length,
								}
							)
							: _vm.n(
								'mail',
								'Favorite {number}',
								'Favorite {number}',
								_vm.selection.length,
								{
									number: _vm.selection.length,
								}
							))+"\n\t\t\t\t")]),_vm._v(" "),_c('ActionButton',{attrs:{"icon":"icon-close","close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.unselectAll.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
						'mail',
						'Unselect {number}',
						'Unselect {number}',
						_vm.selection.length,
						{
							number: _vm.selection.length,
						}
					))+"\n\t\t\t\t")]),_vm._v(" "),(!_vm.account.isUnified)?_c('ActionButton',{attrs:{"icon":"icon-external","close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.onOpenMoveModal.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
						'mail',
						'Move {number} thread',
						'Move {number} threads',
						_vm.selection.length,
						{
							number: _vm.selection.length,
						}
					))+"\n\t\t\t\t")]):_vm._e(),_vm._v(" "),_c('ActionButton',{attrs:{"icon":"icon-forward","close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.forwardSelectedAsAttachment.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
						'mail',
						'Forward {number} as attachment',
						'Forward {number} as attachment',
						_vm.selection.length,
						{
							number: _vm.selection.length,
						}
					))+"\n\t\t\t\t")]),_vm._v(" "),_c('ActionButton',{attrs:{"icon":"icon-delete","close-after-click":true},on:{"click":function($event){$event.preventDefault();return _vm.deleteAllSelected.apply(null, arguments)}}},[_vm._v("\n\t\t\t\t\t"+_vm._s(_vm.n(
						'mail',
						'Delete {number} thread',
						'Delete {number} threads',
						_vm.selection.length,
						{
							number: _vm.selection.length,
						}
					))+"\n\t\t\t\t")])],1),_vm._v(" "),(_vm.showMoveModal)?_c('MoveModal',{attrs:{"account":_vm.account,"envelopes":_vm.selectedEnvelopes,"move-thread":true},on:{"close":_vm.onCloseMoveModal}}):_vm._e()],1):_vm._e()]),_vm._v(" "),_c('transition-group',{attrs:{"name":"list"}},[_c('div',{key:"loading",staticClass:"icon-loading-small",class:{refreshing: _vm.refreshing},attrs:{"id":"list-refreshing"}}),_vm._v(" "),_vm._l((_vm.envelopes),function(env,index){return _c('Envelope',{key:env.databaseId,attrs:{"data":env,"mailbox":_vm.mailbox,"selected":_vm.selection.includes(env.databaseId),"select-mode":_vm.selectMode,"selected-envelopes":_vm.selectedEnvelopes},on:{"delete":function($event){return _vm.$emit('delete', env.databaseId)},"update:selected":function($event){return _vm.onEnvelopeSelectToggle.apply(void 0, [ env, index ].concat( $event ))},"select-multiple":function($event){return _vm.onEnvelopeSelectMultiple(env, index)}}})}),_vm._v(" "),(_vm.loadMoreButton && !_vm.loadingMore)?_c('div',{key:'list-collapse-' + _vm.searchQuery,staticClass:"load-more",on:{"click":function($event){return _vm.$emit('loadMore')}}},[_vm._v("\n\t\t\t"+_vm._s(_vm.t('mail', 'Load more'))+"\n\t\t")]):_vm._e(),_vm._v(" "),_c('div',{key:"loadingMore",class:{'icon-loading-small': _vm.loadingMore},attrs:{"id":"load-more-mail-messages"}})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }